var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 18,
    fill: "#474C5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.75 47C28.5117 47 30.75 44.7617 30.75 42C30.75 39.2383 28.5117 37 25.75 37C22.9883 37 20.75 39.2383 20.75 42C20.75 44.7617 22.9883 47 25.75 47ZM29.25 48.25H28.5977C27.7305 48.6484 26.7656 48.875 25.75 48.875C24.7344 48.875 23.7734 48.6484 22.9023 48.25H22.25C19.3516 48.25 17 50.6016 17 53.5V55.125C17 56.1602 17.8398 57 18.875 57H32.625C33.6602 57 34.5 56.1602 34.5 55.125V53.5C34.5 50.6016 32.1484 48.25 29.25 48.25Z",
    fill: "#343843"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.25 47C61.0117 47 63.25 44.7617 63.25 42C63.25 39.2383 61.0117 37 58.25 37C55.4883 37 53.25 39.2383 53.25 42C53.25 44.7617 55.4883 47 58.25 47ZM61.75 48.25H61.0977C60.2305 48.6484 59.2656 48.875 58.25 48.875C57.2344 48.875 56.2734 48.6484 55.4023 48.25H54.75C51.8516 48.25 49.5 50.6016 49.5 53.5V55.125C49.5 56.1602 50.3398 57 51.375 57H65.125C66.1602 57 67 56.1602 67 55.125V53.5C67 50.6016 64.6484 48.25 61.75 48.25Z",
    fill: "#343843"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42C45.9453 42 49.1429 38.6426 49.1429 34.5C49.1429 30.3574 45.9453 27 42 27C38.0547 27 34.8571 30.3574 34.8571 34.5C34.8571 38.6426 38.0547 42 42 42ZM47 43.875H46.0681C44.8292 44.4727 43.4509 44.8125 42 44.8125C40.5491 44.8125 39.1763 44.4727 37.9319 43.875H37C32.8594 43.875 29.5 47.4023 29.5 51.75V54.1875C29.5 55.7402 30.6998 57 32.1786 57H51.8214C53.3002 57 54.5 55.7402 54.5 54.1875V51.75C54.5 47.4023 51.1406 43.875 47 43.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people_.3974ef94c28ff80be7762203efba7375.svg";
export { ForwardRef as ReactComponent };